const config = {
    isWhiteLabel: localStorage.getItem('isHomePageStatus') == 'true' ? true : false,
    currentTheme:localStorage.getItem("theme") ? localStorage.getItem("theme") :'dark' ,
    // isWhiteLabel: false,
    WhiteLable: window.location.hostname,
    // WhiteLable: 'world777.maruti.dev',
    userData: {},
    isShowInplayInCasino: true,
    TabCricket:'cricket',
    TabVCricket:'virtualcricket',
    TabFootball:'football',
    TabTennis:'tennis',
    TabKabaddi:'kabaddi',
    TabElection:'election',
    TabHorseRacing:'horseracing',
    TabGreyhoundRacing:'greyhound',
    isNightMode:false,
    socketLink:process.env.REACT_APP_NAME === 'World' ? `worldapi.maruti.dev/` : `api.ramiexch.com/`,
    wssLink:`wss://ag-api.maruti.dev/`,
    SpidCricket:'4',
    SpidFootball:'1',
    SpidTennis:'2',
    SpidKabaddi:'400',
    SpidElection:'500',
    SpidHorseRacing:'7',
    SpidGreyhoundRacing:'4339',
    pubObj:[],
    Live:'Live',
    FANCY:"FANCY",
    ColorCricket:'#20327b',
    ColorVirtualCricket:'#581ab4',
    ColorFootball:'#03b37f',
    ColorElection:'#b4845b',
    ColorTenis:'#f18521',
    ColorHorseRacing:'#9e4025',
    ColorGreyhoundRacing:'#e89780',
    ColorKabaddi:'#6e2e26',
    lay:"LAY",
    back:"BACK",
    fancy:"FANCY",
    isNotfancy:"NO-FANCY",
    getDateFormated :'dd-MM-yyyy',
    defualtGame:'All',
    defualtGameVirtual:'All',
    defualtGameSlot:'All',
    Topic_Match_Odds:'/topic/diamond_match_odds_update/',
    Topic_Bookmaker: '/topic/diamond_bm_update/',
    Topic_Fancy: '/topic/diamond_fancy_update/',
    sub_provider:[
      'AvatarUX',
      'AE',
      'Asia Gaming',
      'AvatarUX',
      'BETGAMES',
      'BGaming',
      'BetGames',
      'Beter Live',
      'Betsoft',
      'Big Time Gaming',
      'Blueprint Gaming',
      'Bombay Live',
      'Booming Games',
      'CRASH88 Gaming',
      'CREED',
      'Caleta Gaming',
      'Creedroomz',
      'DARWIN',
      'EA',
      'Evolution Gaming',
      'Evoplay Entertainment',
      'Exchange',
      'Ezugi',
      'FIESTA777',
      'Fantasma',
      'Foxium',
      'Fugaso',
      'GAPLOBBY',
      'Gameburger',
      'Gametech',
      'Gamomat',
      'Gamzix',
      'Golden Race',
      'HORSEBOOK',
      'Habanero',
      'Hacksaw Gaming',
      'JDB',
      'JDB Gaming',
      'JFTW',
      'JiLi Gaming',
      'KINGMAKER',
      'Kalamba Games',
      'Keno',
      'Kingmidas',
      'Kingmidas Gaming',
      'LUDO',
      'Live88',
      'Mac88 Gaming',
      'Mac88 Gaming Virtual',
      'Macaw Gaming',
      'N2Live',
      'Neon Valley',
      'Nmatic',
      'Nolimit City',
      'Northern Lights Gaming',
      'OneTouch',
      'Oryx Gaming',
      'PASCAL',
      'PG',
      'POPOK',
      'Parlaybay',
      'Pascal',
      "Play'n Go",
      'Playson',
      'Playtech',
      'Playtech Live',
      'PopOk',
      'Popok',
      'Popok Instant',
      'Pragmatic Play',
      'Pragmatic Play 2',
      'Pragmatic Play Live',
      'Premium',
      'RICH88',
      'RT',
      'Relax Gaming',
      'Royal Gaming',
      'Royal Gaming Lobby',
      'Royal Gaming Virtual',
      'SABA',
      'SEXYBCRT',
      'SPRIBE',
      'SV388',
      'Slingshot',
      'Smartsoft Gaming',
      'Snowborn Studios',
      'SpinPlay Games',
      'SportsBook',
      'Spribe',
      'Stormcraft',
      'SuperNowa',
      'TURBO',
      'TVBet',
      'Tangente',
      'Triple Edge',
      'TrueLab',
      'Turbogames',
      'VENUS',
      'VegasLounge',
      'Virtual Sports'
    ]
  };

  export default config;
